// extracted by mini-css-extract-plugin
export default {"item":"shared_item__HM0m7","label":"shared_label__6-nIs","children":"shared_children__Qymdp"};